import styled, { keyframes } from 'styled-components';

import { progressLine } from '../../AiManagerRefact/Model/aiProgressLine';

// 말풍선 밖에서 현재 활동 한 줄만 읽어 준다. 움직임 줄이기 설정도 따른다. //
export default function AiProgressTrail(props) {
  const { items, language, initialText, color } = props;

  return (
    <ProgressWrapper
      role='status'
      aria-live='polite'
      aria-atomic='true'
      $color={color}
    >
      <PulseWrapper aria-hidden='true' />
      <span>{progressLine(items, language, initialText)}</span>
    </ProgressWrapper>
  );
}

const pulse = keyframes`
  0%, 100% { opacity: .35; }
  50% { opacity: 1; }
`;

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 4px;
  min-width: 0;
  color: ${props => props.$color};
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
`;

const PulseWrapper = styled.span`
  flex: 0 0 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  animation: ${pulse} 1.5s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
